var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 48C13.8421 47.9926 13.5557 47.8699 13.3429 47.6571C13.1302 47.4444 13.0074 47.158 13 46.8572C13.0018 46.6464 13.021 46.4361 13.0575 46.2286L27.2286 9.25721C27.3603 8.90569 27.5761 8.59178 27.8572 8.34292C28.1232 8.11437 28.5232 8.00006 29.0572 8H32.9429C33.4375 8 33.828 8.11431 34.1143 8.34292C34.4095 8.58499 34.6361 8.90023 34.7715 9.25721L48.8857 46.2287C48.9571 46.4308 48.9957 46.643 49.0001 46.8573C48.9927 47.158 48.8699 47.4444 48.6571 47.6572C48.4444 47.8699 48.158 47.9926 47.8572 48H44.9428C44.4857 48 44.1524 47.8857 43.9428 47.6571C43.7637 47.4748 43.6186 47.2619 43.5143 47.0286L40.3714 38.9142H21.6287L18.4857 47.0286C18.4474 47.2196 18.3143 47.4285 18.0858 47.6571C17.8572 47.8856 17.5143 48 17.0571 48H14.1429ZM23.2857 33.9999H38.7144L30.9996 13.7144L23.2857 33.9999Z",
    fill: "#6F6E74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.073 51H15.927C14.3105 51 13 51.6122 13 52.3673V53.6327C13 54.3878 14.3105 55 15.927 55H46.073C47.6895 55 49 54.3878 49 53.6327V52.3673C49 51.6122 47.6895 51 46.073 51Z",
    fill: "#F9C11B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.673aca150499a1c1ea5fb0f8b7c4aa9d.svg";
export { ForwardRef as ReactComponent };